/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../../../app/bsky/actor/defs.defs.js'

const $nsid = 'tools.ozone.team.defs'

export { $nsid }

type Member = {
  $type?: 'tools.ozone.team.defs#member'
  did: l.DidString
  disabled?: boolean
  profile?: ActorDefs.ProfileViewDetailed
  createdAt?: l.DatetimeString
  updatedAt?: l.DatetimeString
  lastUpdatedBy?: string
  role:
    | 'tools.ozone.team.defs#roleAdmin'
    | 'tools.ozone.team.defs#roleModerator'
    | 'tools.ozone.team.defs#roleTriage'
    | 'tools.ozone.team.defs#roleVerifier'
    | l.UnknownString
}

export type { Member }

const member = l.typedObject<Member>(
  $nsid,
  'member',
  l.object({
    did: l.string({ format: 'did' }),
    disabled: l.optional(l.boolean()),
    profile: l.optional(
      l.ref<ActorDefs.ProfileViewDetailed>(
        (() => ActorDefs.profileViewDetailed) as any,
      ),
    ),
    createdAt: l.optional(l.string({ format: 'datetime' })),
    updatedAt: l.optional(l.string({ format: 'datetime' })),
    lastUpdatedBy: l.optional(l.string()),
    role: l.string<{
      knownValues: [
        'tools.ozone.team.defs#roleAdmin',
        'tools.ozone.team.defs#roleModerator',
        'tools.ozone.team.defs#roleTriage',
        'tools.ozone.team.defs#roleVerifier',
      ]
    }>(),
  }),
)

export { member }

/** Admin role. Highest level of access, can perform all actions. */
type RoleAdmin = 'tools.ozone.team.defs#roleAdmin'

export type { RoleAdmin }

/** Admin role. Highest level of access, can perform all actions. */
const roleAdmin = l.token($nsid, 'roleAdmin')

export { roleAdmin }

/** Moderator role. Can perform most actions. */
type RoleModerator = 'tools.ozone.team.defs#roleModerator'

export type { RoleModerator }

/** Moderator role. Can perform most actions. */
const roleModerator = l.token($nsid, 'roleModerator')

export { roleModerator }

/** Triage role. Mostly intended for monitoring and escalating issues. */
type RoleTriage = 'tools.ozone.team.defs#roleTriage'

export type { RoleTriage }

/** Triage role. Mostly intended for monitoring and escalating issues. */
const roleTriage = l.token($nsid, 'roleTriage')

export { roleTriage }

/** Verifier role. Only allowed to issue verifications. */
type RoleVerifier = 'tools.ozone.team.defs#roleVerifier'

export type { RoleVerifier }

/** Verifier role. Only allowed to issue verifications. */
const roleVerifier = l.token($nsid, 'roleVerifier')

export { roleVerifier }
